import { IHoanPhiCalculateRequest } from "../models/request/hoan-phi/HoanPhiCalculateRequest";
import { apiClient } from "./apiClient";

export const hoanPhiApi = {
    calculate: (data: IHoanPhiCalculateRequest) => apiClient.post(`hoan-phi/calculate`, data),
        tinh_hoan_phi: (request: any) => {
        return apiClient.post('hoan-phi/tinh_hoan_phi', request)
    },
    luu_hoan_phi: (request: any) => {
        return apiClient.post('sf_lichsu_hoanphi/savechanges', request)
    },
    search: (request: any) => {
        return apiClient.post('sf_lichsu_hoanphi/select', request)
    }
}